export default __webpack_public_path__ + "static/rec-s4-7b586e0329465e20ac8e2d6bf55d0e3b.png";